var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "overview" },
    [
      _vm.workspaceAccess &&
      _vm.checklistsOverview &&
      _vm.checklists &&
      _vm.checklists.length !== 0
        ? [
            _c("div", { staticClass: "overview__header" }, [
              _c("h2", [_vm._v("Your workspace overview")]),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c(
                  "a",
                  {
                    staticClass: "button button__secondary button-link",
                    attrs: { href: _vm.viewAllChecklistsUrl, target: "_blank" },
                  },
                  [_vm._v("View all checklists\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "button button__primary button-link",
                    attrs: { href: _vm.createChecklistsUrl, target: "_blank" },
                  },
                  [_vm._v("Create a new checklist\n        ")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overview__content" },
              [
                _vm.checklistsOverview
                  ? [
                      _c("ChecklistStatCard", {
                        attrs: {
                          label: "Checklists",
                          value: _vm.checklistsOverview.checklists,
                          icon: "clipboard-regular",
                        },
                      }),
                      _vm._v(" "),
                      _c("ChecklistStatCard", {
                        attrs: {
                          label: "Recent activity",
                          value: _vm.checklistsOverview.recentActivity,
                          icon: "comments-regular",
                        },
                      }),
                      _vm._v(" "),
                      _c("ChecklistStatCard", {
                        attrs: {
                          label: "Tasks overdue",
                          value: _vm.checklistsOverview.tasksOverdue,
                          icon: "circle-exclamation-solid",
                        },
                      }),
                      _vm._v(" "),
                      _c("ChecklistStatCard", {
                        attrs: {
                          label: "Tasks awaiting responses",
                          value: _vm.checklistsOverview.tasksAwaiting,
                          icon: "circle-question-regular",
                        },
                      }),
                      _vm._v(" "),
                      _c("ChecklistStatCard", {
                        attrs: {
                          label: "Tasks blocked",
                          value: _vm.checklistsOverview.tasksBlocked,
                          icon: "ban-solid",
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _c("div", { staticClass: "get-started" }, [
            _c("div", { staticClass: "get-started__image" }),
            _vm._v(" "),
            _c("div", { staticClass: "get-started__content" }, [
              _c("h2", [_vm._v("Vixio Workspace")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        Start here to discover how Vixio Workspace can transform your\n        regulatory intelligence into actionable tasks. Use a single workspace\n        to create checklists, assign tasks, track progress, capture\n        attestation and stay effortlessly on top of everything.\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "div",
                    { staticClass: "tooltip-assist" },
                    [
                      _vm.workspaceAccess
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "button button__primary start-here button-link",
                              attrs: {
                                href: _vm.createChecklistsUrl,
                                target: "_blank",
                              },
                            },
                            [_vm._v("Start here\n          ")]
                          )
                        : _c(
                            "el-button",
                            {
                              staticClass:
                                "button button__primary start-here button-link",
                              on: { click: _vm.openDemoLink },
                            },
                            [_vm._v("Book a demo\n          ")]
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "button button__secondary",
                      on: { click: _vm.showHowItWorks },
                    },
                    [_vm._v("How it works\n        ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
      _vm._v(" "),
      _c("checklist-video-embed-modal", {
        model: {
          value: _vm.howItWorksVisible,
          callback: function ($$v) {
            _vm.howItWorksVisible = $$v
          },
          expression: "howItWorksVisible",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }